import classNames from "classnames";
import { CheckActiveIcon, CrossActiveIcon } from "../../AscIcons";
import AscImage from "../../AscImage/AscImage";
import AscOptionsSelector from "../../AscOptionsSelector/AscOptionsSelector";
import styles from "./AscQuizQuestion.module.scss";
import { QuizQuestion } from "@ascendnow/shared";

export interface AscQuizQuestionProps {
  className?: string;
  question: QuizQuestion;
  answer?: string;
  onAnswerChange?: (questionId: string, answer: string) => void;
  attemptsCompleted?: boolean;
  disabled?: boolean;
  correctAnswerId?: string;
  questionNumber?: number;
}

export default function AscQuizQuestion({
  className,
  question,
  onAnswerChange,
  answer,
  attemptsCompleted,
  disabled,
  correctAnswerId,
  questionNumber
}: AscQuizQuestionProps) {
  function handleAnswerChange(value: string) {
    onAnswerChange?.(question.id, value);
  }

  return (
    <div
      data-testid="asc-quiz-question"
      className={classNames(styles.ground, className)}
    >
      <div className={styles.question}>
        {questionNumber ? `${questionNumber}.` : ""} {question.question}
      </div>
      {question.coverImageUrl ? (
        <AscImage className={styles.image} src={question.coverImageUrl} />
      ) : null}
      <AscOptionsSelector
        className={styles.optionsSelector}
        size="large"
        value={answer}
        onChange={handleAnswerChange}
        hideArrowIcon
      >
        {question?.answers?.map((a) => (
          <AscOptionsSelector.Option
            key={a?.id}
            label={a?.answer}
            disabled={disabled || attemptsCompleted}
            value={a?.id}
            className={classNames(styles.option, {
              [styles.correct]: a?.id === answer && a?.id === correctAnswerId,
              [styles.incorrect]:
                a?.id === answer &&
                correctAnswerId &&
                correctAnswerId !== a?.id,
            })}
            suffixIcon={
              a?.id === answer && correctAnswerId ? (
                correctAnswerId === a?.id ? (
                  <CheckActiveIcon className={styles.checkIcon} />
                ) : (
                  <CrossActiveIcon className={styles.closeIcon} />
                )
              ) : null
            }
          />
        ))}
      </AscOptionsSelector>
    </div>
  );
}
